/**
 * Network Status Component
 * ========================
 * Affiche une bannière quand l'utilisateur est hors ligne
 */

import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { isNative } from '../hooks/useCapacitor';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Reconnected toast
  if (showReconnected) {
    return (
      <div 
        className="fixed top-0 left-0 right-0 z-[9999] animate-slideDown"
        style={{ paddingTop: isNative ? 'var(--sat, 0px)' : '0' }}
      >
        <div className="bg-green-500 text-white text-center py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium">
          <Wifi size={16} />
          Connexion rétablie
        </div>
      </div>
    );
  }

  // Offline banner
  if (!isOnline) {
    return (
      <div 
        className="fixed top-0 left-0 right-0 z-[9999]"
        style={{ paddingTop: isNative ? 'var(--sat, 0px)' : '0' }}
      >
        <div className="bg-red-500 text-white text-center py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium">
          <WifiOff size={16} />
          Pas de connexion internet
        </div>
      </div>
    );
  }

  return null;
};

export default NetworkStatus;
